import React from 'react';
import { Link } from 'react-router-dom';

export default class CourseCatalogEmbed extends React.Component
{
    constructor(props)
    {
        super(props);
        this.selectCourse = this.selectCourse.bind(this);
        this.getCourses = this.getCourses.bind(this);
        this.state = {
            loaded: false,
            error: "",
            courses: [],
            filteredCourses: [],
            searchTerm: "",
            category: -1 // Auto-Safet
        }
    }
    componentDidMount()
    {
        this.getCourses();
    }
    getCourses()
    {
        this.setState({loaded: false});
        this.props.api.send({
            controller: "Course",
            action: "GetCourses",
            method: "post",
            body: JSON.stringify({categoryID: this.state.category}),
            success: (result) => {
                result.success ?
                    this.setState({loaded: true, courses: result.courses, searchTerm: "", filteredCourses: result.courses}) :
                    this.setState({loaded: true, error: result.message})
            },
            error: (err) => {
                this.setState({loaded: true, error: "Unable to load courses.  Please try again later."})
            }
        })
    }
    searchChanged(e)
    {
        let courses = this.state.courses;
        courses = courses.filter((c) => c.courseName.toLowerCase().match(e.target.value.toLowerCase()));
        this.setState({filteredCourses: courses, searchTerm: e.target.value});
    }
    selectCourse(course)
    {
        this.setState({selectedCourse: course})
    }
    render()
    {
        const cartCoursesIDs = this.props.cart.cartCourses.map((c) => c.courseID);
        const courselist = this.state.filteredCourses.map((c) => 
            <div className={c.owned ? "lmscourse-embed lmscourseowned" : 
                cartCoursesIDs.indexOf(c.courseID) === -1 ? "lmscourse-embed" : 
                "lmscourse-embed lmscartcourse"} key={c.courseID}>
                <div className="lmscourseinner">
                    <div className="lmscoursesummary" style={{backgroundImage: "url('/courses/" + c.courseID + "/Thumb.jpg')" }}>
                        <div className="lmscoursesummaryshroud">
                            <strong>{c.courseName}</strong>
                        </div>
                    </div>
                    <div className={c.owned ? "lmscoursefooter lmscourseownedfooter" :
                        cartCoursesIDs.indexOf(c.courseID) === -1 ? "lmscoursefooter" : 
                            "lmscourseincart lmscoursefooter"}>
                        <Link to="/" target="_blank" onClick={(event) => { event.preventDefault(); window.open("/Courses/" + c.courseID); }} className="lmsbutton">Details</Link>
                        <Link to="/" target="_blank" onClick={(event) => { event.preventDefault(); window.open("/"); }} className="lmsbutton">Add to Cart</Link>

                    </div>
                </div>
            </div>
        )
        return (
            <div className="lmsdisplayarea-embed">
                <div style={{display: "inline", marginLeft: "10%"}}>
                    Search: <input className="lmsforminput" type="text" value={this.state.searchTerm} 
                        onChange={e => this.searchChanged(e)} />
                </div>
                {this.state.loaded ? 
                    this.state.filteredCourses.length > 0 ? (
                        <div className="courselist">
                            {courselist}
                            <div className="lmslibraryfooter">
                                <Link to="/" target="_blank" onClick={(event) => { event.preventDefault(); window.open("/"); }} className="lmsbutton">See More!</Link>
                            </div>
                        </div>
                    ) : (
                        <p>
                            <i>No courses found.</i>
                        </p>
                    ) 
                : (
                    <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/course/catalog/coursecatalog_embed.js